export default __webpack_public_path__ + "static/media/white_check.ab1f131a.png";